import React from "react";
import classes from "./MoreItem.scss";
import { colors } from "Constants";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import I18nHOC from "UIComponents/I18nHOC";
import { onEnterOrSpaceKeyDown } from "Utils";

const placeHolderStyle = {
  borderColor: colors.neutral500,
};

const MoreItem = ({ moreItemsCount, itemText, onMoreClick, t }) => {
  return (
    <div
      className={classes.container}
      onClick={onMoreClick}
      tabIndex={0}
      onKeyDown={e => onEnterOrSpaceKeyDown(e, onMoreClick)}
    >
      <div className={classes.innerContainer}>
        <div className={classes.imagePlaceHolderContainer}>
          <ResourceImagePlaceHolder
            customContainerStyle={placeHolderStyle}
            icon={
              <div className={classes.moreTextIcon}>{`+${moreItemsCount}`}</div>
            }
          />
        </div>
        <div className={classes.moreText}>
          {/* {`+${moreItemsCount} mores ${itemText}${
            moreItemsCount > 1 ? "s" : ""
          }`} */}
          {`+${t("common:more_withNumber_andLabel", {
            number: moreItemsCount,
            label: itemText,
          })}`}
        </div>
      </div>
    </div>
  );
};

export default I18nHOC({ resource: "common" })(MoreItem);
